export const sanitizeOutput = (value?: unknown): string => {
  if (!value) return "An unexpected error occurred";

  const str =
    typeof value === "string" ? value : JSON.stringify(value);

  return str.replace(/[\r\n]/g, "");
};
